import { type PriorityPublicSetValue, priorityScopes } from '../../../common/fields/priority';
import { commonIssueViewGranularScopes } from './fields-scopes';

type PriorityPublicGetValue = {
	id: string;
	name: string;
	iconUrl?: string;
} | null;

type PriorityInternalIdShapeValue = { id: string };

type PriorityInternalFullShapeValue = {
	id: string;
	name: string;
	iconUrl?: string;
} | null;

export const transformPrioritySetValue = (
	value: PriorityPublicSetValue,
): PriorityInternalIdShapeValue => ({ id: value });

export const transformPriorityGetValue = (
	priority: PriorityInternalFullShapeValue,
): PriorityPublicGetValue => {
	if (!priority) {
		return null;
	}

	const { id, name, iconUrl } = priority;
	return {
		id,
		name,
		iconUrl,
	};
};

export const priorityIssueViewScopes = {
	...priorityScopes,
	granular: [...priorityScopes.granular, ...commonIssueViewGranularScopes],
};
